import React, { useContext, useRef } from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import { useDeviationViewContext } from '../../Context';
import DeviationFullView from '../../DeviationViews/Full';
import DuperbrowsePaddles from '../../Duperbrowse/DuperbrowsePaddles';
import StageBackground from '../../DeviationBackground/StageBackground';
import { SubscriptionPurchaseFTUEContext } from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import SubscriptionPurchaseFTUE from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUE';
import StageContainer from '../_partials/StageContainer';
import { useMeasuredStage } from '../hooks/useMeasuredStage';
import s from './DesktopArtStage.scss';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
export var DesktopArtStage = function (_a) {
    var deviation = _a.deviation, className = _a.className, isZoomed = _a.isZoomed, _b = _a.onEnterZoomMode, onEnterZoomMode = _b === void 0 ? function () { return null; } : _b, _c = _a.onExitZoomMode, onExitZoomMode = _c === void 0 ? function () { return null; } : _c;
    var isFullscreen = useDeviationViewContext().isFullscreen;
    var ref = useRef(null);
    var _d = useMeasuredStage(ref, !isFullscreen), contentSize = _d.contentSize, containerSize = _d.containerSize;
    // Ads
    var adsEnabled = useContext(SessionContext).adsEnabled;
    var adsNitro = useFlag('ads_nitro');
    var showAd = adsEnabled && adsNitro;
    var isSubscriptionPurchaseFTUEBeingShown = !!useContext(SubscriptionPurchaseFTUEContext);
    return (React.createElement(StageContainer, { className: classnames(s['root'], className, isFullscreen && s['fullscreen'], showAd && s['with-ad']) },
        React.createElement("div", { className: s['content'], ref: ref },
            React.createElement(StageBackground, { deviation: deviation, height: get(containerSize, 'height'), width: get(containerSize, 'width') }),
            React.createElement(DeviationFullView, { deviation: deviation, height: get(contentSize, 'height'), width: get(contentSize, 'width'), isZoomed: isZoomed, onEnterZoomMode: onEnterZoomMode, onExitZoomMode: onExitZoomMode }),
            React.createElement(DuperbrowsePaddles, { className: s['duperbrowse'] }),
            isSubscriptionPurchaseFTUEBeingShown && React.createElement(SubscriptionPurchaseFTUE, null))));
};
DesktopArtStage.displayName = 'DesktopArtStage';
export default DesktopArtStage;
//# sourceMappingURL=DesktopArtStage.js.map